export const SESSION_STORAGE_KEYS = {
  REDIRECT_AFTER_LOGIN: 'redirectAfterLogin',
  LAST_CHECKED_NOTIFICATION_AT_TENANT: 'lastCheckedNotificationAt_tenant',
  LAST_CHECKED_NOTIFICATION_AT_COMPANY: 'lastCheckedNotificationAt_company',
} as const;

export type SessionStorageKey = (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS];
